export default __webpack_public_path__ + "files/illinois-262b04fe7c047cfa4cf5cc440fde9672.png";